import type { ChinaPaymentType } from '@mypoz/shared';

/**
 * Per request type, in tab order: how it is written in the address (`?type=`), the same form on
 * the old website, and its same-day line (¥1,000 for top-ups and transfers, ¥3,000 for proxy pay).
 * Alipay transfer and WeChat proxy pay are left out: the API has no type for them (China Payment
 * API issues, item 3).
 */
export interface ChinaPaymentTab {
  readonly type: ChinaPaymentType;
  readonly slug: string;
  readonly oldSitePath: string;
  readonly sameDayFromRmbCents: number;
}

/**
 * The first tab, and the one an absent or unknown `?type=` opens. Its own constant so the page
 * never has to index the list (and assert the result) to get it.
 */
export const DEFAULT_CHINA_PAYMENT_TYPE: ChinaPaymentTab = {
  type: 'ALIPAYCHARGE',
  slug: 'alipay',
  oldSitePath: '/index.php/Mypost/Charge/alipay_recharge.html',
  sameDayFromRmbCents: 100_000,
};

export const CHINA_PAYMENT_TYPES: readonly ChinaPaymentTab[] = [
  DEFAULT_CHINA_PAYMENT_TYPE,
  {
    type: 'WXCHARGE',
    slug: 'wechat',
    oldSitePath: '/index.php/Mypost/Charge/weixin_recharge.html',
    sameDayFromRmbCents: 100_000,
  },
  {
    type: 'ALIPAY',
    slug: 'proxy',
    oldSitePath: '/index.php/Mypost/Charge/alipay_paid.html',
    sameDayFromRmbCents: 300_000,
  },
  {
    type: 'BANKTRANS',
    slug: 'bank',
    // The old website's 转账中心 (bank transfer to China) lives at alipay_transfer.html.
    oldSitePath: '/index.php/Mypost/Charge/alipay_transfer.html',
    sameDayFromRmbCents: 100_000,
  },
];

/** `?type=` values, for the routes that redirect the old three pages here. */
export const CHINA_PAYMENT_TYPE_SLUGS = {
  topUp: 'alipay',
  proxyPayment: 'proxy',
  transfer: 'bank',
} as const;
